import { FieldConfig } from "../../../SetupFormGenerator/types";
import {
  DEFAULT_FORM_OF_INCOME_FIELD,
  DEFAULT_INTERNAL_NOTES_FIELD,
  DEFAULT_MARK_RECURRING_PAYMENT_FIELD,
  DEFAULT_PAY_PERIOD_FIELD,
  DEFAULT_RECURRING_CADENCE_FIELD,
} from "../DEFAULT/constants";
import { COMPONENTLIST } from "../../../SetupFormGenerator/constants";
import {
  DecoratedMessageWithLinkDisplayType,
  DecoratedMessageWithLinkType,
} from "../../../../../../../components/MessageWithLink/types";

export enum TaxableBenefits {
  CAR_OR_COMMUTER_ALLOWANCE = "Car or Commuter Allowance",
  EDUCATION = "Education",
  INTERNET_OR_PHONE_ALLOWANCE = "Internet or Phone Allowance",
  MEAL_ALLOWANCE = "Meal allowance",
  WORK_FROM_HOME_ALLOWANCE = "Work from home allowance",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);

export const TaxableBenefitsTypeMessage: {
  [key: string]: DecoratedMessageWithLinkType;
} = {
  [TaxableBenefits.CAR_OR_COMMUTER_ALLOWANCE]: {
    text: "Maximum amount to be tax-exempt is €300 per year for conventional fuel vehicles and €600 for alternative fuel vehicles.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
} as const;

export const FR_FUEL_TYPE_FIELD: FieldConfig = {
  label: "Fuel Type",
  name: "fuelType",
  type: COMPONENTLIST.RADIO,
  options: [
    {
      value: "conventional",
      label: "Conventional Fuel",
      description: "Vehicles that utilize petrol or diesel.",
    },
    {
      value: "alternative",
      label: "Alternative Fuel",
      description:
        "Vehicles that utilize hybrid, electric, or hydrogen power. ",
    },
  ],
  required: true,

  renderCheck: (data) => {
    const paymentSettings = data?.setUp?.payload?.paymentSettings;
    const benefitType =
      paymentSettings && "benefitType" in paymentSettings
        ? (paymentSettings as { benefitType?: string }).benefitType ?? ""
        : "";
    return benefitType === TaxableBenefits.CAR_OR_COMMUTER_ALLOWANCE;
  },
};

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] = [
  FR_FUEL_TYPE_FIELD,
  DEFAULT_FORM_OF_INCOME_FIELD,
  DEFAULT_PAY_PERIOD_FIELD,
  DEFAULT_MARK_RECURRING_PAYMENT_FIELD,
  DEFAULT_RECURRING_CADENCE_FIELD,
  DEFAULT_INTERNAL_NOTES_FIELD,
];
